<template>
  <v-container>
    <v-row justify="end" align-content="end" class="pt-1">
      <v-spacer />
      <v-btn
        rounded
        dense
        small
        color="primary"
        @click="handleAddDocument"
        :disabled="!canUserComment"
      >
        <v-icon> mdi-plus </v-icon>
        {{ $t('document.newLink') }}
      </v-btn>
    </v-row>
    <v-row>
      <v-col><h2> {{ $t('document.contractSection') }} </h2></v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <documents-table :documents="contractDocuments" />
      </v-col>
    </v-row>
    <v-row>
      <v-col><h2> {{ $t('document.guaranteeSection') }} </h2></v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <documents-table :documents="guaranteesDocuments" show-source />
      </v-col>
    </v-row>
    <v-row>
      <v-col><h2> {{ $t('document.paymentSection') }} </h2></v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <documents-table :documents="paymentsDocuments" show-source />
      </v-col>
    </v-row>
    <v-row>
      <v-col><h2> {{ $t('document.variationSection') }} </h2></v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <documents-table :documents="variationDocuments" show-source />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { addDocumentToContract } from '@/services'

export default {
  name: 'DocumentsList',
  props: {
    documents: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return { }
  },
  computed: {
    contractDocuments () {
      return this.documents.filter(i => !i.paymentApplications.length && !i.variations.length && !i.guarantees.length)
    },
    paymentsDocuments () {
      return this.documents
        .filter(i => i.paymentApplications.length)
        .map(doc => ({ ...doc, source: doc.paymentApplications[0].name }))
    },
    variationDocuments () {
      return this.documents
        .filter(i => i.variations.length)
        .map(doc => ({
          ...doc,
          source: `${doc.variations[0].type[0].toUpperCase() + doc.variations[0].type.slice(1)} - ${doc.variations[0].name} (${doc.variations[0].no})`
        }))
    },
    guaranteesDocuments () {
      return this.documents
        .filter(i => i.guarantees.length)
        .map(doc => ({
          ...doc,
          source: doc.guarantees[0].name
        }))
    },
    ...mapState({
      canUserComment: state => state.userPermissionsToContract.canUserComment
    })
  },
  methods: {
    handleAddDocument () {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'DocumentForm',
        options: { maxWidth: 650 },
        scope: {
          title: this.$t('document.add')
        },
        handlers: {
          SAVE_DOCUMENT: async (document) => {
            await addDocumentToContract(document, this.$route.params.contractId)
            this.$eventBus.$emit('CLOSE_MODAL')
            this.$eventBus.$emit('FETCH_CONTRACT')
          }
        }
      })
    }
  }
}
</script>
